export default "__VITE_ASSET__DCMywNlA__"